import { render, staticRenderFns } from "./kyc-review-log-table.vue?vue&type=template&id=d751ee52"
import script from "./kyc-review-log-table.vue?vue&type=script&lang=js"
export * from "./kyc-review-log-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports